(function () {
    "use strict";

    angular.module('app').controller("InstallationScreeningController", InstallationScreeningController);

    InstallationScreeningController.$inject = ["controllerDecorator", "screeningService", "$scope", "$timeout", "installationScreening", "installationRequest", "logbook", "arrayUtilities"];
    function InstallationScreeningController(controllerDecorator, screeningService, $scope, $timeout, installationScreening, installationRequest, logbook, arrayUtilities) {

        const context = { id: null };

        const vm = this;
        controllerDecorator.Decorate(vm, ["files", "dialog", "forms", "comments", "navigation"]);

        vm.InspectionResult = {
            Add: addInspectionResult,
            CanAdd: () => vm.request && vm.request.Screening.Status === 30
        };

        vm.States = [{ Key: '10' }, { Key: '40' }, { Key: '51' }, { Key: '60' }, { Key: '130' }, { Key: '140' }, { Key: '160' }, { Key: '170' }];

        function addInspectionResult() {

            const defaultDate = new Date();
            defaultDate.setFullYear(defaultDate.getFullYear() + 5);

            $scope.InspectionResult = {
                IsApproved: false,
                ApprovedUntil: defaultDate
            };
        }

        $scope.ShouldConfirmDate = () => {
            if ($scope.InspectionResult?.IsApproved !== true)
                return false;

            if (!$scope.InspectionResult?.ApprovedUntil)
                return false;

            return habilCommon.dateUtils.isDateWithinMonths(new Date($scope.InspectionResult.ApprovedUntil), 6);
        };

        vm.InspectionResult.Options = {
            templateUrl: "@/installation/inspection-result.html",
            scope: $scope,
            onEscape: true,
            title: vm.getTranslation("InspectionResult_DialogTitle"),
            buttons: {
                ok: {
                    label: vm.getTranslation("Button_Confirm"),
                    className: "btn-primary",
                    callback: onSubmitInspectionResult,
                },
                cancel: {
                    label: vm.getTranslation("Button_Cancel"),
                    className: "btn-default"
                }
            },
            onHidden: () => { $scope.InspectionResult = null; },
            size: "large"
        };

        function onSubmitInspectionResult() {
            if (!$scope.inspectionResultForm.$valid) {
                return false;
            }

            const model = $scope.InspectionResult;

            if ($scope.ShouldConfirmDate() && model.ConfirmApprovedUntil !== true) {
                $timeout(() => model.HasError = true);
                return false;
            }

            // Clear the default date when the inspection does not result in approval
            if (!model.IsApproved)
                model.ApprovedUntil = null;

            vm.SetLoadingState(true);
            installationScreening.RegisterInspection(
                { RequestId: vm.request.PublicId, Result: model },
                r => {
                    if (r.data.IsApproved) {
                        load();
                    }
                    else {
                        vm.request.Inspections.push(r.data);

                        vm.SetLoadingState(false);
                    }
                },
                vm.ShowError
            );
            return true;
        }

        vm.DownloadExtract = downloadExtract;
        vm.CanAccept = () => vm.request.Screening.Status === 10;
        vm.Accept = acceptScreenings;
        vm.CanSign = () => vm.request.Screening.Status === 40;
        vm.Sign = sign;
        vm.SaveRemark = vm.Api.SaveBaseRemark;

        vm.IsRemarkActive = (screening) => screening.Remark && (screening.Status == 10 || screening.Status == 30);
        vm.CanReject = () => vm.request.Screening.Status < 40 && !vm.request.Screening.Remark.IsValid && vm.request.Screening.Remark.Description !== null;
        vm.Reject = () => installationScreening.Reject({ PublicId: vm.request.PublicId }, _ => vm.Navigator.GoToDashboard(), vm.ShowError);

        vm.AddLogEntry = function () {
            vm.NewEntry = {};
            vm.Dialog.Custom(addEntryDialogSetting);
        };

        vm.DeleteLogEntry = deleteEntry;

        activate();

        function activate() {
            // Parse url
            const parsed = vm.ParsePrettyUrl();
            context.id = parsed.id;

            load();
        }

        function load() {
            installationRequest.Get(
                context.id,
                r => {
                    vm.request = r.data;
                    vm.Comments.Initialize({ RequestId: context.id, DossierId: null, OrganisationId: vm.request.Organisation.PublicId, ICD: vm.request.ScreeningBy });
                },
                vm.ShowError,
                () => vm.SetLoadingState(false)
            );

        }

        function downloadExtract() {
            vm.SetLoadingState(true);
            installationScreening.DownloadExtract(
                vm.request.PublicId,
                vm.ShowError,
                () => vm.SetLoadingState(false)
            );
        }

        function acceptScreenings() {
            vm.SetLoadingState(true);
            installationScreening.Accept(
                { ScreeningIds: [vm.request.Screening.PublicId] },
                response => {
                    if (response.data)
                        load();
                },
                vm.ShowError,
                () => vm.SetLoadingState(false)
            );
        }

        function sign() {
            screeningService.signInstallations({ Type: "installations", Items: [{ PublicId: vm.request.PublicId }] })
                .then(r => authenticateBeforeSigning(r))
                .catch(vm.ShowError);
        }

        /**
        * Checks if the API call succeeded and prompts the user to authenticate themselves using their eId
        * @param {Object} result the result from an API call
        */
        function authenticateBeforeSigning(result) {
            if (!CheckResultReceived(result)) {
                vm.ShowError(result);
                return;
            }

            const options = {
                onEscape: true,
                closeButton: true,
                title: vm.getTranslation("GetFasRedirectionTitle"),
                templateUrl: vm.Settings.applicationPath + 'Account/ChangeFASLogin?returnurl=' + encodeURIComponent(vm.Navigator.CurrentPage)
            };
            vm.Dialog.Custom(options);
        }

        const addEntryDialogSetting = {
            templateUrl: "@/logbook/new-entry.html",
            onEscape: true,
            scope: $scope,
            size: "medium",
            title: vm.getTranslation("Logbook_NewEntry_Title"),
            buttons: {
                ok: {
                    label: vm.getTranslation("Button_Save"),
                    className: "btn-primary",
                    callback: () => {
                        if (!$scope.newEntryForm.$valid) {
                            vm.ShowError(vm.getTranslation("Form_CannotSubmit_PleaseFixValidationErrors"));
                            return false;
                        }
                        submitEntry();
                    }
                },
                cancel: {
                    label: vm.getTranslation("Button_Cancel"),
                    callback: angular.noop
                }
            }
        };

        function submitEntry() {
            logbook.CreateEntry(
                { RequestId: vm.request.PublicId, Entry: vm.NewEntry },
                r => {
                    vm.request.LogBookEntries.push(r.data);
                    delete vm.NewEntry;
                },
                vm.ShowError
            );
        }

        function deleteEntry(entry) {
            logbook.DeleteEntry(
                entry.PublicId,
                () => {
                    arrayUtilities.RemoveItem([entry]);
                },
                vm.ShowError
            );
        }
    }
})();
